import { useMutation } from '@tanstack/react-query';
import { exchangeSsoHandoff } from './sso.repository';

const SSO_EXCHANGE_FAILED_MESSAGE = 'sso handoff exchange failed without an error payload';

export const useExchangeSsoHandoffMutation = () =>
  useMutation({
    mutationFn: async (handoffCode: string) => {
      const response = await exchangeSsoHandoff(handoffCode);

      if (!response.ok || !response.data) {
        throw response.originalError ?? new Error(SSO_EXCHANGE_FAILED_MESSAGE);
      }

      return response.data;
    },
  });
